


import { Navigate, Route, Routes } from "react-router-dom"
import { Squares2X2Icon } from "@heroicons/react/24/outline"
import { RouteElement } from "../../../interfaces/_common"
import { SubMenuTabs } from "../common"
import RouteKeys from '../../../constants/route-keys'
import { IconMasterListing } from './IconManagement/IconMasterListing'

const _routes: RouteElement[] = [
    {
        route: 'icons',
        title: 'Icon Master',
        key: RouteKeys.ICONS,
        component: IconMasterListing,
        icon: Squares2X2Icon,
        display: true
    },

]

const IconMaster = () => {
    return (
        <div>
            <SubMenuTabs _routes={_routes}/>
            <div className="p-3">
                <Routes>
                    <Route path='' element={<Navigate to={_routes[0].route} replace/>}>
                    </Route>
                    {_routes.map(route => (
                        <Route path={route.route} key={'master' + route.route} element={<route.component />} />
                    ))}
                </Routes>
            </div>
        </div>
    )
}

export default IconMaster